import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-marketplace-page-v1',
  templateUrl: './marketplace-page-v1.component.html',
  styleUrl: './marketplace-page-v1.component.scss',
})
export class MarketplacePageV1Component implements OnInit {
  private marketplaceService = inject(MarketplaceService);

  ngOnInit() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
  }
}
